import { MdChevronLeft } from "react-icons/md";
import styles from "../style";
import { Reveal } from "./reveal";
import { FiArrowUp } from "react-icons/fi";
import { LogoIcon } from "../assets";

const Heroabout = () => {
  return (
    <div className={`pt-80 ${styles.flexCenter} flex-col w-full`}>
      <div className={`${styles.flexCenter} flex-col xl:px-0 sm:px-16 px-6`}>
        <div className="flex flex-col gap-4 justify-between items-center w-full">          
          <Reveal>
            <h1 className="kerning-normal px-10 text-center text-white font-semibold xs:text-lg text-md leading-[50px] xs:leading-[50px] xs:max-w-[740px] max-w-[400px]">
             Local capital for local brilliance.
            </h1>
          </Reveal>
          <Reveal>
            <p className={`kerning-normal text-md font-semibold xs:max-w-[470px] max-w-[360px] text-center text-white`}>
              Us for Us. 
            </p>
          </Reveal>
        </div>     
      </div>
      

      <div className="flex flex-col justify-between items-center w-full">
        <Reveal>
          <h1 className="kerning-normal pt-20 px-10 text-center text-tertiary font-medium text-mm leading-[30px] xs:leading-[30px] max-w-[420px]">
            We back disruptive, African-led, tech-enabled startups and creator ventures.
          </h1>
        </Reveal>
        <div className="flex flex-row gap-4 items-center pt-48">
          <span className="border-b border-1 border-second xs:w-[200px] w-[150px]"></span>
          <img
            src={LogoIcon}
            alt="HSL"
            className="w-[50px] h-[50px] object-contain"
          />
          <span className="border-b border-1 border-second xs:w-[200px] w-[150px]"></span>
        </div>
      </div>

      <div className={`flex flex-col mt-20 gap-4 animate-pulse ${styles.flexCenter}`}>        
        <p className={`kerning-normal text-ss max-w-[470px] mt-5 text-center text-second`}>
          Scroll Up
        </p>
        <FiArrowUp color="#916D41" size={24} className="animate-bounce" />
      </div>

      
    </div>
  );
};

export default Heroabout;
